// lib/estate.ts — small helpers for the property page.
type U = Record<string, any>;
type B = Record<string, any>;

/** A building's one-line description: storeys, height and its Building Safety Act standing. */
export const buildingMeta = (b: B) =>
  `${b.floors ? `${b.floors} storeys` : 'Storeys not recorded'}${b.heightMetres ? ` · ${b.heightMetres}m` : ''}${b.isHigherRisk ? ` · higher-risk${b.bsrRegistrationNumber ? ` · ${b.bsrRegistrationNumber}` : ' · not registered'}` : ''}`;

/** Units grouped under their building; units with no building (or whose building is gone) come last under `null`. */
export function groupUnits(units: U[], buildings: B[]): Array<{ building: B | null; units: U[] }> {
  const by = new Map<string, U[]>();
  for (const u of units) {
    const k = u.buildingId && buildings.some((b) => b.id === u.buildingId) ? u.buildingId : '';
    by.set(k, [...(by.get(k) ?? []), u]);
  }
  const loose = by.get('') ?? [];
  return [...buildings.map((b) => ({ building: b, units: by.get(b.id) ?? [] })), ...(loose.length || !buildings.length ? [{ building: null, units: loose }] : [])];
}
